import { MessageCircle, Mail, Phone, ArrowUpRight } from "lucide-react";
import { LOGO_URL, CONTACT } from "@/lib/data";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
};

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-[#0A0E14] border-t border-white/10 pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <h2 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none">
              Pronto a<br />
              <span className="text-[#00C8D7]">stampare?</span>
            </h2>
            <button
              data-testid="footer-cta"
              onClick={() => scrollTo("quote")}
              className="mt-8 group inline-flex items-center gap-2 bg-[#F5871F] text-[#0A0E14] font-bold px-8 py-4 hover:bg-[#F5871F]/85 transition-colors"
            >
              Parla del tuo progetto
              <ArrowUpRight size={20} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-500">Contatti</span>
            <div className="mt-5 space-y-4">
              <a
                data-testid="footer-whatsapp"
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-slate-300 hover:text-[#00C8D7] transition-colors"
              >
                <MessageCircle size={18} /> WhatsApp · {CONTACT.phoneText}
              </a>
              <a
                data-testid="footer-phone"
                href={CONTACT.phone}
                className="flex items-center gap-3 text-slate-300 hover:text-[#00C8D7] transition-colors"
              >
                <Phone size={18} /> {CONTACT.phoneText}
              </a>
              <a
                data-testid="footer-email"
                href={CONTACT.email}
                className="flex items-center gap-3 text-slate-300 hover:text-[#00C8D7] transition-colors"
              >
                <Mail size={18} /> {CONTACT.emailText}
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-500">Servizi</span>
            <div className="mt-5 space-y-3 text-slate-400">
              <p>Stampa 3D FDM</p>
              <p>Prototipazione rapida</p>
              <p>Piccoli lotti su misura</p>
              <p>Consulenza file STL</p>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="copypro3d.it" className="h-9 w-9 rounded-full object-cover" />
            <span className="font-display font-bold">
              copypro<span className="text-[#00C8D7]">3d</span>.it
            </span>
          </div>
          <p className="font-mono-tech text-xs text-slate-500 text-center">
            © {new Date().getFullYear()} copypro3d.it — Stampa 3D Professionale · Italia
          </p>
          <a
            data-testid="footer-admin-link"
            href="/admin/login"
            className="font-mono-tech text-xs text-slate-600 hover:text-[#00C8D7] transition-colors"
          >
            Area riservata
          </a>
        </div>
      </div>
    </footer>
  );
}
